import { useQuery } from '@tanstack/react-query';
import { can, type Permission } from '@pti/domain';
import { api } from './api';
import type { Me } from './types';

export function useMe() {
  return useQuery({ queryKey: ['me'], queryFn: () => api.get<Me>('/api/me') });
}

export function useCan() {
  const { data } = useMe();
  return (p: Permission) => !!data && can(data.user.roles, p);
}
